import { Record, List } from 'immutable';
import CountryRecord from '~/data/CountryRecord';
import LanguageRecord from '~/data/LanguageRecord';
import InvoiceFormRecord from './InvoiceFormRecord';

const keys: Fields = {
  countries: List(),
  invoiceFormData: new InvoiceFormRecord(),
  invoiceLanguages: List(),
};

export interface Fields {
  countries: List<CountryRecord>;
  invoiceFormData: InvoiceFormRecord;
  invoiceLanguages: List<LanguageRecord>;
}

export default class SubscriptionAccountRecord extends Record<Fields>(keys) {
  constructor(props?) {
    super(props);
    return this.merge(props);
  }

  merge(values) {
    return super.merge(this.__get(values));
  }

  __get(values) {
    if (!values) {
      return {};
    }

    const newValues: Partial<Fields> = Object.keys(keys).reduce((acc, key) => {
      if (values[key]) {
        acc[key] = values[key];
      }
      return acc;
    }, {});

    if (values.invoiceFormData) {
      newValues.invoiceFormData = new InvoiceFormRecord(values.invoiceFormData);
    }

    if (values.invoiceLanguages) {
      newValues.invoiceLanguages = List(
        values.invoiceLanguages.map((invoiceLanguage) => new LanguageRecord(invoiceLanguage))
      );
    }

    if (values.countries) {
      newValues.countries = List(values.countries.map((country) => new CountryRecord(country)));
    }
    return newValues;
  }
}
